<div class="animated fadeIn">
  <div class="row sfapp-container">
    <div class="col-md-12">
      <div class="card">
        <div class="card-header">
          <span><i class="fa s-icon-edit"></i>&nbsp;申請</span>
        </div>
        <div class="card-body">
          <form novalidate #notificationForm="ngForm" class="col-md-12" (ngSubmit)="save()">
            <div style="height: 1px"></div>
            <div class="row">
              <div class="col-md-12">
                <div class="mb-3 row">
                  <div class="col-md-4"><span>現在の区分コース名：</span></div>
                  <div class="form-group col-md-8"><span>{{ member.studioPlan?.name }}</span></div>
                </div>
              </div>
            </div>
            <strong>区分コース変更申請</strong>
            <hr />
            <div class="row">
              <div class="col-md-12">
                <div class="form-group row">
                  <div class="col-md-6">
                    <label class="col-form-label">変更する区分コース名</label>
                    <select class="form-control" [(ngModel)]="select.studioPlan" name="studioPlan" required>
                      <option [ngValue]="null">選択してください</option>
                      @for (plan of studioPlans; track plan.id) {
                        <option [ngValue]="plan">{{ plan.name }}</option>
                      }
                    </select>
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-md-6">
                    <label class="col-form-label">区分コース変更月</label>
                    <select class="form-control" [(ngModel)]="select.startDate" name="startDate" required>
                      <option [ngValue]="null">選択してください</option>
                      @for (opt of startDateOptions; track opt.id) {
                        <option [ngValue]="opt">{{ opt.name }}</option>
                      }
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <br /><br />
            <div class="row">
              <div class="d-none d-sm-block col-md-12 text-right">
                <button routerLink="/notification" class="btn bg-close text-white"><i class="fa s-icon-cancel"></i>&nbsp;閉じる</button>
                <button type="submit" class="btn btn-success ml-1" [disabled]="notificationForm.invalid || isButtonDisable"><i class="fa s-icon-finished"></i>&nbsp;申請</button>
              </div>
              <div class="d-block d-sm-none col-12">
                <button type="submit" class="btn btn-success col-12 form-group" [disabled]="notificationForm.invalid || isButtonDisable"><i class="fa s-icon-finished"></i>&nbsp;申請</button>
                <button routerLink="/notification" class="btn bg-close text-white col-12 form-group"><i class="fa s-icon-cancel"></i>&nbsp;閉じる</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
